export enum PagePath {
  clients = "/clients",
  emailJobRequests = "/emailJobRequests",
  mtJobRequests = "/mtJobRequests",
  externalApiJobRequests = "/externalApiJobRequests",
  quoteJobRequests = "/quoteRequests",
  analytics = "/analytics",
  systemSettings = "/systemSettings",
  staffAccounts = "/staffAccounts"
}
